export default "__VITE_ASSET__9d13242f__"